import { Typography } from "@mui/material";

const CurrencyListItem = ({ currencyName }: { currencyName: string }) => {
    return (
        <Typography>
            <strong>{currencyName}</strong>
        </Typography>
    );
};

export default CurrencyListItem;
